import { LucideIcon } from 'lucide-react';

interface SectionHeaderProps {
    icon: LucideIcon;
    title: string;
    className?: string;
}

const SectionHeader = ({ icon: Icon, title, className = "" }: SectionHeaderProps) => (
    <div className={`flex items-center gap-3 mb-6 ${className}`}>
        <div className="p-2 rounded-lg bg-purple-500/10 text-purple-400">
            <Icon size={20} />
        </div>
        <h2 className="text-xl font-bold text-white font-serif tracking-wide">{title}</h2>
    </div>
);

export default SectionHeader;
